/**
 * The progress chart is shown by default except for the conditions checked in this function.
 * @param {*} report 
 * @param {*} selectedLocale 
 * @param {*} notEarlyReaderCount 
 * @returns 
 */
export default function shouldShowChart(report) {
  
  const activities = report?.data || [];

  const onlyContainERSSWithNoARMScore = activities.every(
    (activity) => {
      return (
        activity.storyTags.some(tag => tag.startsWith("ERSS-")) &&
        !activity.storyTags.includes("EARLY_READER_WORD_LIST") &&
        !activity.storyTags.includes("EARLY_READER_REPETITIVE_TEXT")
      );
    }
  );

  const onlyContainProgressMonitoringAndNoARMScore = activities.every(
    (activity) => {
      return (
        activity.storyTags.includes("progressMonitoring") &&
        !activity.scores?.currentArmEstimate && 
        !activity.scores?.armScore &&
        !activity.score
      );
    }
  );

  if(onlyContainERSSWithNoARMScore){
    return false;
  }

  if(onlyContainProgressMonitoringAndNoARMScore){
    return false
  }

  return true;
}